(() => {
  'use strict';
  const root = document.getElementById('nana-concept') || document.body;
  const menu = root.querySelector('.n-menu');
  const mobileNav = root.querySelector('.n-mobile-nav');
  const reducedMotion = window.nanaMotion || window.matchMedia('(prefers-reduced-motion: reduce)');
  document.addEventListener('pointerdown', () => {
    document.documentElement.dataset.nanaInput = 'pointer';
  }, {capture: true, passive: true});
  document.addEventListener('keydown', () => {
    document.documentElement.dataset.nanaInput = 'keyboard';
  }, {capture: true});
  const phone = document.querySelector('.nx-phone-disclosure');
  if (phone) {
    document.addEventListener('click', event => {
      if (!phone.contains(event.target)) phone.open = false;
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && phone.open) {
        phone.open = false;
        phone.querySelector('summary').focus();
      }
    });
  }

  document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
    const main = gallery.querySelector('[data-main-image]');
    const caption = gallery.querySelector('[data-gallery-status]');
    const buttons = [...gallery.querySelectorAll('[data-gallery-image]')];
    if (!main) return;
    let imageAnimation = null;
    let selection = 0;
    const stopImageMotion = () => {
      selection += 1;
      if (imageAnimation) imageAnimation.cancel();
      imageAnimation = null;
    };
    reducedMotion.addEventListener('change', stopImageMotion);
    window.addEventListener('pagehide', stopImageMotion);
    document.addEventListener('visibilitychange', () => { if (document.hidden) stopImageMotion(); });
    buttons.forEach(button => button.addEventListener('click', event => {
      if (button.getAttribute('aria-pressed') === 'true') return;
      stopImageMotion();
      const currentSelection = selection;
      main.src = button.dataset.galleryImage;
      main.removeAttribute('srcset');
      main.alt = button.querySelector('img').alt;
      buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      if (caption) caption.textContent = button.dataset.position + ' / ' + buttons.length;
      if (event.detail === 0 || reducedMotion.matches || !main.animate) return;
      const ready = main.decode ? main.decode() : Promise.resolve();
      ready.catch(() => {}).then(() => {
        // Rapid selections and preference changes must never replay an old image.
        if (selection !== currentSelection || reducedMotion.matches || document.hidden || !main.complete || !main.naturalWidth) return;
        imageAnimation = main.animate([
          {opacity: .35, transform: 'scale(1.035)'},
          {opacity: 1, transform: 'scale(1)'}
        ], {duration: 240, easing: 'cubic-bezier(.16,1,.3,1)'});
        const started = imageAnimation;
        started.finished.then(() => { if (imageAnimation === started) imageAnimation = null; }, () => {});
      });
    }));
  });

  const purchase = document.querySelector('[data-product-purchase]');
  if (purchase) {
    const quantity = purchase.querySelector('[name="quantity"]');
    const variant = purchase.querySelector('[name="id"]');
    const checkout = purchase.querySelector('[data-checkout]');
    if (checkout) {
      const updateCheckout = () => {
        const valid = quantity.validity.valid;
        checkout.setAttribute('aria-disabled', String(!valid));
        if (valid) {
          const url = new URL(checkout.href);
          url.pathname = '/cart/' + variant.value + ':' + Number(quantity.value);
          url.searchParams.set('locale', document.documentElement.lang);
          checkout.href = url.href;
        }
      };
      quantity.addEventListener('input', updateCheckout);
      checkout.addEventListener('click', event => {
        if (!quantity.reportValidity()) event.preventDefault();
      });
      updateCheckout();
    }
  }

  function closeMenu(restoreFocus = false) {
    if (!menu || !mobileNav) return;
    mobileNav.hidden = true;
    menu.setAttribute('aria-expanded', 'false');
    menu.setAttribute('aria-label', 'Open navigation');
    if (restoreFocus) menu.focus({preventScroll: true});
  }
  if (menu && mobileNav) {
  menu.addEventListener('click', () => {
    const open = menu.getAttribute('aria-expanded') !== 'true';
    menu.setAttribute('aria-expanded', String(open));
    menu.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation');
    mobileNav.hidden = !open;
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && !mobileNav.hidden) closeMenu(true);
  });
  new ResizeObserver(() => {
    if (getComputedStyle(menu).display === 'none') closeMenu();
  }).observe(root);
  }

  function openHashTarget() {
    const target = document.getElementById(location.hash.slice(1));
    if (target instanceof HTMLDetailsElement) target.open = true;
  }
  openHashTarget();
  window.addEventListener('hashchange', openHashTarget);

  document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', event => {
      const target = document.getElementById(link.hash.slice(1));
      if (!target) return;
      event.preventDefault();
      closeMenu();
      if (phone && phone.contains(link)) phone.open = false;
      if (target instanceof HTMLDetailsElement) target.open = true;
      target.scrollIntoView({behavior: reducedMotion.matches || event.detail === 0 ? 'instant' : 'smooth', block: 'start'});
      history.pushState(null, '', link.hash);
      target.setAttribute('tabindex', '-1');
      target.focus({preventScroll: true});
      target.addEventListener('blur', () => target.removeAttribute('tabindex'), {once:true});
    });
  });

  // Only the local preview uses this form. Shopify renders its native contact form.
  document.querySelectorAll('form[data-contact-preview]').forEach(form => {
    form.querySelector('button[type="submit"]').disabled = false;
    form.addEventListener('submit', event => {
      event.preventDefault();
      form.querySelector('[role="status"]').textContent = document.documentElement.lang === 'es'
        ? 'Vista previa comprobada. No se ha enviado ningún mensaje. Para contactar ahora: mynurclinic@gmail.com.'
        : 'Preview checked. No message has been sent. To contact the clinic now: mynurclinic@gmail.com.';
    });
  });

  const grid = document.querySelector('.nx-product-grid');
  if (grid) {
    const products = [...grid.querySelectorAll('.nx-product')];
    const filters = [...document.querySelectorAll('[data-filter]')];
    const sort = document.getElementById('nx-product-sort');
    const count = document.getElementById('nx-product-count');
    const spanish = document.documentElement.lang === 'es';
    const stateKey = 'nana-catalog-v1';
    const params = new URL(location.href).searchParams;
    let saved = {};
    try { saved = JSON.parse(sessionStorage.getItem(stateKey) || '{}') || {}; } catch (_) {}
    const categories = filters.map(button => button.dataset.filter);
    const sorts = [...sort.options].map(option => option.value);
    const requestedCategory = params.get('category') || saved.category;
    const requestedSort = params.get('sort') || saved.sort;
    let category = categories.includes(requestedCategory) ? requestedCategory : 'all';
    sort.value = sorts.includes(requestedSort) ? requestedSort : 'name';
    function renderCatalog() {
      const ordered = [...products].sort((a, b) => {
        if (sort.value === 'price-low') return Number(a.dataset.price) - Number(b.dataset.price);
        if (sort.value === 'price-high') return Number(b.dataset.price) - Number(a.dataset.price);
        return a.querySelector('h3').textContent.localeCompare(b.querySelector('h3').textContent, spanish ? 'es' : 'en');
      });
      let visible = 0;
      ordered.forEach(product => {
        product.hidden = category !== 'all' && !product.dataset.categories.split(' ').includes(category);
        if (!product.hidden) visible += 1;
        grid.append(product);
      });
      filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === category)));
      const selected = filters.find(button => button.dataset.filter === category);
      count.textContent = `${visible} ${spanish ? 'artículo' : 'product'}${visible === 1 ? '' : 's'}${category === 'all' ? '' : ` · ${selected.textContent}`}`;
      try { sessionStorage.setItem(stateKey, JSON.stringify({category, sort:sort.value})); } catch (_) {}
      const stateUrl = new URL(location.href);
      stateUrl.searchParams.set('category', category);
      stateUrl.searchParams.set('sort', sort.value);
      history.replaceState(history.state, '', stateUrl);
    }
    filters.forEach(button => button.addEventListener('click', () => {category = button.dataset.filter; renderCatalog();}));
    sort.addEventListener('change', renderCatalog);
    renderCatalog();
  }
})();
